export type GrantOpportunityComment = {
  id: number;
  grant_opportunity_id: number;
  user_id: number;
  parent_id: number | null;
  author_name: string;
  body: string;
  created_at: string;
};

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

function commentsPath(municipalityId: number, opportunityId: number): string {
  return `/api/v1/municipalities/${municipalityId}/grant_opportunities/${opportunityId}/comments`;
}

export async function listGrantOpportunityComments(
  municipalityId: number,
  opportunityId: number,
): Promise<GrantOpportunityComment[]> {
  const response = await fetch(commentsPath(municipalityId, opportunityId), {
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error("Failed to load comments");
  }
  return response.json();
}

export async function createGrantOpportunityComment(
  municipalityId: number,
  opportunityId: number,
  body: string,
  parentId?: number | null,
): Promise<GrantOpportunityComment> {
  const response = await fetch(commentsPath(municipalityId, opportunityId), {
    method: "POST",
    credentials: "include",
    headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
    body: JSON.stringify({
      grant_opportunity_comment: {
        body,
        ...(parentId != null ? { parent_id: parentId } : {}),
      },
    }),
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.errors?.join(", ") ?? "Failed to post comment");
  }
  return response.json();
}
